module.exports = __webpack_public_path__ + "img/w4.2b5a4842.png";